import { render, staticRenderFns } from "./AddCbtQuestions.vue?vue&type=template&id=324dafa9&scoped=true"
import script from "./AddCbtQuestions.vue?vue&type=script&lang=js"
export * from "./AddCbtQuestions.vue?vue&type=script&lang=js"
import style0 from "./AddCbtQuestions.vue?vue&type=style&index=0&id=324dafa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324dafa9",
  null
  
)

export default component.exports